import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { ProblemAgitation } from './components/ProblemAgitation';
import { TargetAudience } from './components/TargetAudience';
import { SolutionIntro } from './components/SolutionIntro';
import { ModulesGrid } from './components/ModulesGrid';
import { BonusesGrid } from './components/BonusesGrid';
import { ComparisonTable } from './components/ComparisonTable';
import { PricingSection } from './components/PricingSection';
import { ProEliteUpsell } from './components/ProEliteUpsell';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-brand-dark text-brand-text font-body selection:bg-brand-orange selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <TestimonialsStrip data-id="element-3" />
      <ProblemAgitation data-id="element-4" />
      <TargetAudience data-id="element-5" />
      <SolutionIntro data-id="element-6" />
      <ModulesGrid data-id="element-7" />
      <BonusesGrid data-id="element-8" />
      <ComparisonTable data-id="element-9" />
      <PricingSection data-id="element-10" />
      <ProEliteUpsell data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}